<!-- No rows -->
<div
  fxLayout="column" fxLayoutAlign="center center"
  class="gd-spreadsheet-editor-v2-no-rows">

  <!-- Image -->
  <div
    class="gd-spreadsheet-editor-v2-no-rows-image"></div>

  <!-- Message -->
  <div
    class="gd-spreadsheet-editor-v2-no-rows-text">{{'LNG_COMMON_LABEL_EMPTY_TABLE' | translate}}</div>
</div>
